// @flow

import type {
  PropsSchema,
  EasyAction,
  EventSourceMap,
  BasicProps
} from '../../type'
import type { Props as EasyCompProps } from '../EasyCompComponent'

import * as React from 'react'
import { getPageInfo } from '../../pageInfo'
import computeData from '../hoc/computeData'
import rootComp from '../hoc/rootComp'

type EasyCompElement = React.Element<React.ComponentType<EasyCompProps>>;
type Props = BasicProps & {
  style: { [string]: string },
  events: EventSourceMap,
  children: React.ChildrenArray<EasyCompElement>,
  actionPushPage: (
    data: { h5: string, app?: ?string },
    dynamicData: any
  ) => void
};

@computeData({ includeVisible: false })
@rootComp
export default class Root extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      event: 'ready',
      title: '就绪'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '页面跳转',
      name: 'pushPage',
      dataSchema: [
        {
          key: 'h5',
          title: '跳转到 H5 网页'
        }
      ]
    },
    {
      title: '去登录',
      name: 'toLogin',
      dataSchema: [
        {
          key: 'backUrl',
          title: '登录后返回的页面（不填则为当前页面）',
          placeholder: '不填返回到当前页面'
        }
      ]
    }
  ];

  componentDidMount () {
    this.props.callActions('ready')
  }

  actionToLogin = (data: ?{ backUrl?: string }, dynamicData: any) => {
    let marketplace = getPageInfo().marketplace
    let { backUrl } = data || {}
    backUrl = backUrl || window.location.href
    let h5 =
      marketplace === 'abroad'
        ? `/gblwx/login?outback=${encodeURIComponent(backUrl)}`
        : ''
    this.props.actionPushPage(
      {
        h5
      },
      dynamicData
    )
  };

  render () {
    const { id, style, children } = this.props
    return (
      <div
        style={{ position: 'relative', minHeight: '100%', ...style }}
        id={id}
      >
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/RootPc.js